module.exports = __webpack_public_path__ + "img/SDG-17-EN.f35a9e1d.png";